import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loggedIn: false,
    userType: "",
    username: "",
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        logIn: (_state, { payload: { userType, username } }) => ({
            loggedIn: true,
            userType,
            username,
        }),
        logOut: () => initialState,
    },
});

export const { logIn, logOut } = authSlice.actions;

export default authSlice;
